/**
 * The words for a role IN a company (SB-321). A company admin and the platform role are different
 * things (SB-24), so the platform role is never called «Administrator» beside a company: it reads
 * «SuccessBuilder-administrator» in the user menu, and here, where it works in a company without
 * being a member, «SuccessBuilder-tilgang».
 */
import type {CompanyRole} from '../api/companies';

export function companyRoleLabel(role: CompanyRole | null | undefined): string {
    if (role === 'admin') return 'Administrator';
    if (role === 'member') return 'Medlem';
    return 'SuccessBuilder-tilgang';
}
